import { render } from "./ActiveUsersChart.vue?vue&type=template&id=4ba9d52a"
import script from "./ActiveUsersChart.vue?vue&type=script&lang=js"
export * from "./ActiveUsersChart.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__